var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69416 22.0462C11.8849 18.8571 15.2635 14 23 14C30.7365 14 34.1152 18.8571 36.3058 22.0462L36.3161 22.0612C36.5414 22.3892 36.7671 22.7177 36.9819 23.0144C36.2824 24.5344 35.0436 26.7633 32.8741 28.6205C30.6806 30.4981 27.5315 32 23 32C18.4685 32 15.3194 30.4981 13.1259 28.6205C10.9564 26.7633 9.71762 24.5344 9.01808 23.0144C9.23287 22.7177 9.45847 22.3893 9.68372 22.0614L9.69416 22.0462ZM8.04564 20.9138C10.2644 17.6838 14.1688 12 23 12C31.8312 12 35.7356 17.6838 37.9544 20.9138C38.2034 21.2764 38.4313 21.608 38.6424 21.8972C39.039 22.4404 39.1115 23.1654 38.8308 23.7806C38.0785 25.4291 36.6873 27.989 34.1747 30.1398C31.629 32.319 28.0216 34 23 34C17.9784 34 14.371 32.319 11.8253 30.1398C9.31271 27.989 7.92148 25.4291 7.16922 23.7806C6.88847 23.1654 6.96097 22.4404 7.35757 21.8972C7.56874 21.608 7.79655 21.2764 8.0456 20.9138L8.04564 20.9138ZM29.9998 23C29.9998 26.866 26.8658 30 22.9998 30C19.1338 30 15.9998 26.866 15.9998 23C15.9998 19.134 19.1338 16 22.9998 16C26.8658 16 29.9998 19.134 29.9998 23ZM20.2866 19.703C20.6576 20.0127 20.7073 20.5645 20.3976 20.9355C19.159 22.4195 19.3578 24.6266 20.8418 25.8653C21.2128 26.1749 21.2625 26.7267 20.9529 27.0977C20.6432 27.4687 20.0914 27.5184 19.7204 27.2088C17.4945 25.3508 17.1961 22.0401 19.0541 19.8141C19.3638 19.4431 19.9156 19.3934 20.2866 19.703Z",
    fill: "#003E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.8726fb45b1047a18981b47fabb262070.svg";
export { ForwardRef as ReactComponent };